<template>
    <div>
        <el-dialog
            title="成员列表"
            :visible.sync="showdialog"
            width="800px"
            @close="close">
                <div class="base-warp">
                    <div class="head">
                        <div class="btn-box">
                            <el-button type="primary" size="mini" @click="add">添加管理员</el-button>
                        </div>
                    </div>
                    <div class="table-box">
                        <el-table 
                        :data="tableData" 
                        border 
                        :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                            <el-table-column type="index" label="序号" width="60"></el-table-column>
                            <el-table-column prop="name" label="账号"></el-table-column>
                            <el-table-column prop="password" label="密码"></el-table-column>
                            <el-table-column prop="telephone" label="手机"></el-table-column>
                            <el-table-column prop="realName" label="真名"></el-table-column>
                            <el-table-column prop="forbidden" label="禁用" align="center">
                                <template slot-scope="s">
                                    <span v-if="!s.row.forbidden" class="text-success">正常</span>
                                    <span v-else class="text-danger">禁用</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="city" label="管理城市" align="center"></el-table-column>
                            <el-table-column label="操作" width="150">
                                <template slot-scope="s">
                                    <el-button type="warning" size="mini" v-if="!s.row.forbidden" @click="forbidden(s.row)">禁用</el-button>
                                    <el-button type="success" size="mini" v-if="s.row.forbidden" @click="forbidden(s.row)">恢复</el-button>
                                    <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
                <el-dialog
                    title="添加管理员"
                    :visible.sync="adddialog"
                    width="900px"
                    append-to-body
                    @closed="cleardata">
                        <el-form :model="form" ref="form" :rules="rules" label-width="80px" :inline="false" size="normal">
                            <el-form-item label="账号" prop="name">
                                <el-input v-model="form.name"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" prop="password">
                                <el-input v-model="form.password"></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码" prop="repassword">
                                <el-input v-model="form.repassword"></el-input>
                            </el-form-item>
                            <el-form-item label="手机" prop="telephone">
                                <el-input v-model="form.telephone"></el-input>
                            </el-form-item>
                            <el-form-item label="真实姓名" prop="realName">
                                <el-input v-model="form.realName"></el-input>
                            </el-form-item>
                            <el-form-item label="管理城市" prop="city">
                                <el-select v-model="form.city" clearable placeholder="请选择">
                                    <el-option
                                    v-for="(item,index) in city"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="confirm">添加</el-button>
                                <el-button @click="cleardata">取消</el-button>
                            </el-form-item>
                        </el-form>
                        
                </el-dialog>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            showdialog: true,
            tableData: [],
            id: '',
            pageNo: 1,
            pagesize: 10,
            adddialog: false,
            total: 0,
            form: {
                name: '',
                password: '',
                repassword: '',
                telephone: '',
                realName: '',
                city:"",
            },
            city:['全部'],
            rules: {
                name: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                    { min: 2, max: 16, message: '长度在 2 到 16 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' }
                ],
                repassword: [
                    { required: true, message: '请确认密码', trigger: 'blur' },
                    { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' }
                ],
                telephone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 11, max: 11, message: '手机号长度不对，请确认', trigger: 'blur' }
                ],
                realName: [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' },
                ],
                city: [
                    { required: true, message: '请选择管理城市', trigger: 'blur'}
                ]
            },
        }
    },
    computed:{
        managedCity(city){
            if(city === ''){
                city = '全部'
            }
            return city
        }
    },
    mounted () {
        var id = this.$route.query.id;
        this. id = id;
        this.getTableDataById();
        this.getCityList();
    },
    methods: {
        getCityList() {
            this.$api.getCityList("").then((data) => {
                data.forEach(item=>{
                    this.city.push(item.label)
                })
            });
        },
        confirm() {
            this.$confirm(`确认选择管理城市为${this.form.city}？添加后不可修改`).then(
                confirm=>{
                    this.$refs.form.validate((valid) => {
                        if (valid) {
                            if (this.form.password!=this.form.repassword){
                                this.$message.error('两次输入的密码不一样');
                                return;
                            }
                            var params = {
                                id: this.id,
                                name: this.form.name,
                                password: this.form.password,
                                telephone: this.form.telephone,
                                realName: this.form.realName,
                                city: this.form.city,
                            };
                            this.$api.addAdminUser(params).then(
                                data=>{
                                    this.$message.success(data);
                                    this.pageNo = 1;
                                    this.getTableDataById();
                                    this.cleardata();
                                }
                            )
                        } else {
                            return false;
                        }
                    });
                },
                cancel=>{},
            )

        },
        add() {
            this.adddialog = true;
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableDataById();
        },
        getTableDataById() {
            var params = {
                id:  this.id,
                pageNo: this.pageNo,
                pagesize: this.pagesize
            }
            this.$api.getAdminUserList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        close() {
            this.$router.go(-1);
        },
        forbidden(row) {
            var params = {
                id: row._id['$oid'],
                forbidden: !row.forbidden,
            }
            this.$api.forbiddenAdminUser(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTableDataById();
                }
            )
        },
        del(row) {
            this.$confirm('是否确定删除'+row.name+'?').then(
                confirm=>{
                    var params = {
                        id: row._id['$oid'],
                    };
                    this.$api.delAdminUser(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getTableDataById();
                        }
                    )
                },
                cancel=>{}
            )
        },
        cleardata(){
            this.form = {
                name: '',
                password: '',
                repassword: '',
                telephone: '',
                realName: '',
                city:"",
            },
            this.adddialog = false;
        }
    },
}
</script>

<style lang="scss" scoped>
.base-warp{
    .head{
        padding-bottom: 10px;
        margin-bottom: 10px;
        .btn-box{
            text-align: right;
        }
    }
}
</style>